module.exports = __webpack_public_path__ + "static/img/avatar_2.5a66f4a.png";


//////////////////
// WEBPACK FOOTER
// ./static/avatars/avatar_2.png
// module id = 1593
// module chunks = 61